import { NavLink } from 'react-router-dom';
import ProfileSidebar from '../../components/ProfileSidebar';
import React, { useState, useRef, ChangeEvent } from 'react';
import { FaUpload } from 'react-icons/fa6';
import NoticeComponent from '../../components/NoticeComponent';
import TextEditor from "../../components/texteditor/TextEditor";

export default function Seller() {
  const [bannerImage, setBannerImage] = useState<string | null>(null);
  const [userImage, setUserImage] = useState<string | null>(null);
  const [bio, setBio] = useState<string>(''); // 상태 추가
  const bannerInputRef = useRef<HTMLInputElement | null>(null);
  const userImageInputRef = useRef<HTMLInputElement | null>(null);

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setBannerImage(imageUrl);
    }
  };

  const handleBannerClick = () => {
    if (bannerInputRef.current) {
      bannerInputRef.current.click();
    }
  };

  const handleUserImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUserImage(imageUrl);
    }
  };

  const handleUserImageClick = () => {
    if (userImageInputRef.current) {
      userImageInputRef.current.click();
    }
  };

  return (
    <section className="w-full mx-auto">
      <div className="flex flex-col flex-1 overflow-auto w-full">
        <div className="flex items-stretch flex-row justify-between w-full mx-auto">
          <article className="h-full w-full">
            <div className="w-full h-full flex flex-col items-center">
              <div className="w-full pb-12">
                <NoticeComponent title="대쉬보드" content="" />
                <div className="relative w-full" onClick={handleBannerClick}>
                  {bannerImage ? (
                    <img
                      src={bannerImage}
                      alt="배너"
                      className="w-full h-[330px] object-cover rounded-lg shadow-md"
                    />
                  ) : (
                    <div className="w-full h-[284px] flex items-center justify-center rounded-md bg-slate-800 hover:bg-opacity-90 transition duration-300 ease-in-out">
                      <div className="flex flex-col items-center gap-3">
                        <span className="flex items-center gap-2 text-base font-bold text-MainColor">
                          <FaUpload /> 배너 업로드
                        </span>
                        <span className="text-white/80 text-sm font-light">
                          (최적 사이즈: 2000x284 픽셀)
                        </span>
                      </div>
                    </div>
                  )}
                  <input
                    type="file"
                    ref={bannerInputRef}
                    className="hidden"
                    onChange={handleImageUpload}
                  />
                </div>

                <div className="flex flex-col justify-center items-stretch w-full mt-10">
                  <section className="w-full">
                    <div className="w-full flex items-stretch justify-between gap-6">
                      <div className="flex items-center flex-col gap-5">
                        <div className="flex flex-col w-full">
                          <label htmlFor="name" className="text-sm font-semibold text-MainTextColor mb-2">
                            이름
                          </label>
                          <input
                            id="name"
                            type="text"
                            className="w-full px-4 py-2 h-[43px] rounded-md bg-gray-100 text-MainTextColor border border-gray-200 focus:outline-none focus:ring focus:ring-MainColor transition duration-200"
                            placeholder="이름을 입력하세요"
                          />
                        </div>

                        <div className="mt-4 w-full">
                          <label htmlFor="userImage" className="text-sm font-bold text-MainTextColor mb-2">
                            프로필 이미지
                          </label>
                          <div
                            className="w-[182px] h-[182px] mt-2 relative border border-gray-200 rounded-lg cursor-pointer hover:shadow-lg transition duration-200"
                            onClick={handleUserImageClick}
                          >
                            {userImage ? (
                              <img
                                src={userImage}
                                alt="유저 이미지"
                                className="w-full h-full object-cover rounded-lg"
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-lg">
                                <span className="text-sm text-gray-400">이미지 업로드</span>
                              </div>
                            )}
                            <input
                              type="file"
                              ref={userImageInputRef}
                              className="hidden"
                              onChange={handleUserImageUpload}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="flex-grow h-[275px]">
                        <label htmlFor="bio" className="text-sm font-semibold text-MainTextColor mb-1 block">
                          내 정보
                        </label>
                        <TextEditor // TextEditor 컴포넌트 사용
                          value={bio}
                          onChange={setBio}
                          height="300px"
                        />
                        <div className="text-right text-sm text-gray-400 mt-1">{bio.length}/500</div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
